import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-but_computer",
  "use": "icon-but_computer-usage",
  "viewBox": "0 0 15.501 13.999",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.501 13.999\" id=\"icon-but_computer\">\n  <defs>\n  </defs>\n  <path id=\"icon-but_computer_联合_77\" data-name=\"联合 77\" class=\"cls-1\" d=\"M-3947-1559v-1h9v1Zm4-1v-2h-7v-11h15v3.167l-1-.667v-1.5h-13v9h13v-1.5l1-.667V-1562h-7v2Zm5.5-7h-5.5v-1h5.5v-1.5l3,2-3,2Z\" transform=\"translate(3950 1573)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol